export default "__VITE_ASSET__Ioad4C3v__"